export default __webpack_public_path__ + "static/media/CD_Login_screen_Picture_quxto6_c_scale,w_1400.1ec2d14d.jpg";